module.exports = __webpack_public_path__ + "static/media/69.16a371af.jpg";